// extracted by mini-css-extract-plugin
export default {"mainContainer":"MasterLayout_mainContainer__F90Xa","dashboardContainer":"MasterLayout_dashboardContainer__3LKyp"};